import { MdlDialogReference } from '@angular-mdl/core';
import { ChangeDetectionStrategy, Component, Inject, InjectionToken } from '@angular/core';
import { SampleTrackingDialogResult, SampleTrackingResultAction } from '../../service/dialog-service/sample-tracking-result';
import { ReportData } from '../interfaces/report-data';

export const DELETE_REPORT_TOKEN = new InjectionToken('DeleteReportItem');

@Component({
    selector: 'delete-report',
    template: require('./delete-report.component.html'),
    styles: [require('./delete-report.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class DeleteReportComponent  {

    public reportData: ReportData;
    public reportType: string;

    constructor(private dialog: MdlDialogReference,
                @Inject(DELETE_REPORT_TOKEN) private readonly reportInfo: ReportData) {

        this.reportData = reportInfo;
        this.reportType = reportInfo.scheduledContent ? 'Scheduled' : 'Saved';
    }

    public close() {

        const result: SampleTrackingDialogResult = {
            action: SampleTrackingResultAction.close,
        };

        this.dialog.hide(result);
    }
    
    public async deleteReport() {

        const result: SampleTrackingDialogResult = {
            action: SampleTrackingResultAction.deleteReport,
        };

        this.dialog.hide(result);
    }
}